document.addEventListener('DOMContentLoaded', function() {
    const policyTitles = document.querySelectorAll('.shopify-policy__title');
    const svgElement = document.querySelector('.arrow_svg__wrapper_policies-arrow');
  
    policyTitles.forEach(title => {

if (title.firstElementChild && title.firstElementChild.tagName === 'H1') {
    const h2 = document.createElement('h2');
    h2.classList.add("policies-headline");
    h2.innerHTML = title.firstElementChild.innerHTML;
    title.replaceChild(h2, title.firstElementChild);
  }
      
      title.classList.add('arrow-flex');
      const clone = svgElement.cloneNode(true);
      clone.style.display = 'inline';
      clone.id = ''; // Remove the id to avoid duplicate ids
      // Append the cloned SVG element to the end of the policy title
      title.appendChild(clone);
    });
  
    // Remove the original SVG element from its initial position
    svgElement.parentNode.removeChild(svgElement);
});